import useApi from './useApi';
import { endpoints } from './endpoints';
import { IDescLangs } from '../types/interfaces/IDescLangs';

interface IData {
  languages: IDescLangs[];
}

const useDescLangs = () => {
  const { data } = useApi<IData>(endpoints.constants);

  const reduceLangsList = (fields: any, key: any) =>
    languagesList.reduce((acc: any, cv: any) => ({ ...acc, [cv.key]: fields[cv.key][key].value }), {});

  const currentLangFields = (fields: any) => {
    const currentLang = Object.keys(fields)[0];
    return Object.keys(fields[currentLang]).reduce((acc, key) => ({ ...acc, [key]: fields[currentLang][key].value }), {});
  };

  const languagesList: IDescLangs[] = data?.languages || [];

  return { languagesList, reduceLangsList, currentLangFields };
};

export default useDescLangs;
